import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import { BaseApi } from './base-api.service';
import { environment as ENV } from '../environments/environment';
import { BehaviorSubject, Observable, Subject, from, map, switchMap, tap, of } from 'rxjs';
import { BaseApi } from './base-api.service';

export interface SpinnerData {
  showSpinner: boolean;
  spinnerWithMessage: boolean;
  subText: string;
  stepper: number;
}

@Injectable({
  providedIn: 'root'
})
export class ApplicantService {

  // private applicantId: string;
  // private baseUrl: string;
  // private custId: string;
  dataObj: any;

  private neslDataEncrypted = new BehaviorSubject<any>('');
  neslDataShared = this.neslDataEncrypted.asObservable()
  // getBaseUrl: string;

  public stringSubject = new Subject<SpinnerData>();
  public showToolBar = new Subject<string>();
  freshOrResume: any;
  loginReferenceId: any;
  loginReferenceName: any;

  constructor(
    private api: BaseApi,
    private http: HttpClient,
  ) {

  }

  getApplicantID() {
    return sessionStorage.getItem("appId");
  }


  moreInfoOld(res: any) {
    console.log('check rest', res)
    if (res && res.moreInfo != null && res.moreInfo != "" && res.moreInfo != undefined) {
      if (res.message == 'Success' || res.message == 'success') {
        return res.moreInfo.errorid + "-" + res.moreInfo.errormsg
      }
      else if (res && res.message != 'Success' && res.moreInfo && res.moreInfo.errDetail && res.moreInfo.errDetail.errorid) {
        let error2 = res.moreInfo.url ? res.moreInfo.url : res.moreInfo.err;
        return res.message + " - " + res.moreInfo.errDetail.errorid + " - " + res.moreInfo.errDetail.errormsg + "\n" + " - " + error2;
      }
      else if (res && res.message != 'Success' && res.moreInfo && res.moreInfo.errorid) {
        return res.message + " - " + res.moreInfo.errorid + " - " + res.moreInfo.errormsg
      }
      else {
        return "";
      }
    }
    else {
      return "";
    }
  }

  getResumeData(appId) {
    return this.api.getComplt(`/v1/applicant/getApplicantRecord/${appId}`).pipe(
      map(resp => {
        return resp;
      })
    )
  }

  getDigidata() {

    let applicantId = sessionStorage.getItem('appId');
    return this.api.postData('/v1/digi/getDigiData', { applicantId: applicantId }).pipe(map(res => {
      return res;
    }))
  }

  generateLink(payload) {
    return this.api.postData('/v1/customer/encryptedLink', payload)
  }

  goldLink(payload){
    return this.api.postData('/v1/customer/sendGoldLink', payload)
  }

  goldDetails(){
    let applicantId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/gold/getGoldDetails?applicantId=${applicantId}`).pipe(map(res => {
      return res;
    }))
  }

  generateEmailLink(payload) {
    return this.api.postData('/v1/customer/encryptedEmailLink', payload)
  }


  genereateOTPSelf(payload) {
    return this.api.postData("/v1/dfid/generateLoginOtp", payload).pipe(map(res => {
      return res;
    }))
  }

  verifyOTPSelf(payload) {
    return this.api.postData("/v1/dfid/verifyLoginOtp", payload).pipe(map(res => {
      return res;
    }))
  }

  getUserInfoDigi(code) {
    let applicantId = sessionStorage.getItem('appId');
    var authObj = {
      applicantId: applicantId,
      clientId: ENV.digilocker.clientId,
      code: code,
      clientSecret: ENV.digilocker.clientSecret,
      redirectUri: ENV.digilocker.redirect_Uri
    }
    return this.api.postData('/v1/digi/accessToken', authObj)
      .pipe(map(res => {
        return res
      }));
  }


  getAccessToken() {
    let applicantId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/digi/getAccessToken/${applicantId}`)
      .pipe(map(res => {
        return res
      }));
  }


  updateDigiData(path, data, type) {

    let applicantId = sessionStorage.getItem('appId');

    console.log("update digi data in applicant service");

    if (type === "data") {
      this.dataObj = {
        applicantId: applicantId,
        digidata: data,
        type: type,
        index: null,
        accesspath: "",
      };
    } else if (type === "access_path") {
      this.dataObj = {
        applicantId: applicantId,
        digidata: data,
        type: type,
        index: 0,
        accesspath: path,
      };
    }

    return this.api.postData('/v1/digi/updateDigiData', this.dataObj)
      .pipe(map(res => {
        // return res 
        console.log("response in Applicant Service " + JSON.stringify(res));
        return res;
      }));
  }


  getFile(fileUri, token, containerName, basePath) {

    let applicantId = sessionStorage.getItem('appId');
    return this.api.postData('/v1/digi/fileFromUri', { uri: fileUri, token: token, applicantId: applicantId, containerName: containerName, basePath: basePath })
      .pipe(map(res => {
        // return res 
        console.log("responseeee " + JSON.stringify(res));
        return res;
      }));
  }


  getIssueDocuments(token) {
    return this.api.postData('/v1/digi/getissuedDoc', { token: token })
      .pipe(map(res => {
        return res
      }));

  }

  getEverything(bankName?: string) {
    let appId = sessionStorage.getItem('appId');

  let url = bankName
    ? `/v1/autoFill/autoFillLoanApplication/${appId}/${bankName}`
    : `/v1/autoFill/autoFillLoanApplication/${appId}`;

  return this.api.getComplt(url).pipe(map(res => res));
  }


  getCarDetails() {
    let appId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/autoFill/autoFillCarLoanApplication/${appId}`).pipe(map(res => {
      return res
    }));
  }


  getVoterDetails() {
    let appId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/bVoter/viewBusinessVoter/${appId}`).pipe(map(result => {

      return result;
    }))
  }


  getCicCheck() {
    let applicantId = sessionStorage.getItem('appId');
    return this.api.postData(`/v1/generate/crif/breScore`, { 
  "applicantId": applicantId,
  "vendorId": "whatsloan",
  "packageId": "6a3cbd4e650064bdc98614cc",
  "allowRescoring": true
 }).pipe(map(result => {

      return result;
    }))
  }



  getEverythingCo() {
    // let appId = sessionStorage.getItem('');
    let appId = sessionStorage.getItem('CoApplicantId');
    return this.api.getComplt(`/v1/autoFill/autoFillLoanApplication/${appId}`).pipe(map(res => {
      return res
    }));
  }


  getEverythingGuarantor(appId, bankName: string = 'apcob') {
    // let appId = sessionStorage.getItem('');
    // let appId = sessionStorage.getItem('CoApplicantId');
    return this.api.getComplt(`/v1/autoFill/autoFillLoanApplication/${appId}/${bankName}`).pipe(map(res => {
      return res
    }));
  }

  consideredGuarantors(data) {
    return this.api.postData('/v1/customer/consideredGarrantor', data).pipe(map(res => {
      console.log("considered guarantor sending data ", data);
      return res;
    }));
  }
  getCarLoanBreStatus(data) {
    return this.api.postData('/v1/bre/scienaptic/carLoan', data).pipe(map(res => {
      return res;
    }))
  }

  updateFormData(data) {
    return this.api.postData('/v1/autoFill/submit-formData', data).pipe(map(res => {
      return res;
    }))
  }

  saveForm(data) {
    return this.api.postData('/v1/autoFill/save-form', data).pipe(map(res => {
      return res;
    }))
  }


  getFormData(data) {
    return this.api.postData('/v1/autoFill/getFormData', data).pipe(map(res => {
      return res;
    }))
  }

  logout(token, auth) {
    return this.api.postData('/v1/digi/revokeToken', { token: token, auth: auth })
      .pipe(map(res => {
        return res
      }));
  }


  verifyEmailOtp(post) {
    return this.api.postData("/v1/customer/verifyEmailLink", post).pipe(map(resp => {
      return resp;
    }))
  }


  linkStatus() {
    return this.api.getComplt(`/v1/customer/getVerificationStatus/${sessionStorage.getItem("appId")}`).pipe(map(resp => {
      return resp;
    }))
  }


  EmailStatus() {
    return this.api.getComplt(`/v1/customer/getEmailStatus/${sessionStorage.getItem("appId")}`).pipe(map(resp => {
      return resp;
    }))
  }

  getLandBreStatus() {

    let applicantId = sessionStorage.getItem('appId');

    return this.api.postData("/v1/loan/landBRECalculation", { "applicantId": applicantId }).pipe(map(resp => {
      return resp;
    }))
  }

  getLandBre() {

    let applicantId = sessionStorage.getItem('appId');

    return this.api.postData("/v1/land-record/landBREScore", 
      { "applicantId": applicantId,
        "vendorId": "whatsloan",
        "packageId": "6a3e703bf3a62cf78091c20a",
       "allowRescoring": true,
       },
    ).pipe(map(resp => {
      return resp;
    }))
  }

  calculateAndSaveSahyadriFarmsLoanEligibility(tenureDays, requestedLoanAmount, existingOutstandingLoan?, existingOutstandingFFC?, role?) {
    let applicantId = sessionStorage.getItem('appId');
    let adminId = sessionStorage.getItem('adminId');

    let payload: any;
    if (role === 'checker') {
      payload = {
        "existingOutstandingLoan": existingOutstandingLoan,
        "existingOutstandingFFC": existingOutstandingFFC,
        "adminId": adminId,
        "applicantId": applicantId,
      };
    } else {
      payload = {
      "applicantId": applicantId,
      "tenureDays": tenureDays,
      "requestedLoanAmount": requestedLoanAmount
      };
      if (existingOutstandingLoan != null) {
        payload.existingOutstandingLoan = existingOutstandingLoan;
      }
      if (existingOutstandingFFC != null) {
        payload.existingOutstandingFFC = existingOutstandingFFC;
      }
    }

    return this.api.postData("/v1/sahyadriFarmsBre/calculateAndSaveLoanEligibility", payload).pipe(map(resp => {
      return resp;
    }))
  }

  submitSahyadriFarmsBreDecision(role, decision, changedAmount?) {
    let applicantId = sessionStorage.getItem('appId');
    let adminId = sessionStorage.getItem('adminId');

    const payload: any = {
      "applicantId": applicantId,
      "adminId": adminId,
      "role": role,
      "decision": decision
    };
    if (changedAmount != null) {
      payload.changedAmount = changedAmount;
    }

    return this.api.postData("/v1/sahyadriFarmsBre/decision", payload).pipe(map(resp => {
      return resp;
    }))
  }

  sendSahyadriFarmsCustomerApprovalLink(link) {
    let applicantId = sessionStorage.getItem('appId');

    return this.api.postData("/v1/sahyadriFarmsBre/sendCustomerApprovalLink", {"applicantId": applicantId,"link": link}).pipe(map(resp => {
      return resp;
    }))
  }

  submitSahyadriFarmsCustomerApproval(decision: boolean) {
    let applicantId = sessionStorage.getItem('appId');
    return this.api.postData("/v1/sahyadriFarmsBre/customerApproval", {
      "applicantId": applicantId,
      "decision": decision
    }).pipe(map(resp => {
      return resp;
    }))
  }


  getDistrictsAP() {
    return this.api.getComplt(`/v1/land/meebhoomi/getDistricts?applicantId=${sessionStorage.getItem('appId')}`).pipe(
      map(admin => {
        return admin;
      })
    )

  }

  getDistrictsUP() {

    let requestId = sessionStorage.getItem('AgriappId');

    return this.api.getComplt(`/v1/land/uttarpradesh/getDistrict?requestId=${requestId}`).pipe(
      map(admin => {
        return admin;
      })
    )
  }

  getDistrictsOD() {

    let requestId = sessionStorage.getItem('AgriappId');

    return this.api.getComplt(`/v1/odisha/land/getDistrict?applicantId=${requestId}`).pipe(
      map(admin => {
        return admin;
      })
    )
  }



  fetchLandrecordsUP(uq) {
    let applicantId = sessionStorage.getItem('AgriappId')
    return this.api.getComplt(`/v1/land/uttarpradesh/fetchLand?applicantId=${applicantId}`).pipe(map(resp => {
      return resp;
    }))
  }//used by odisha 

  fetchLandrecordsUttarPradesh() {
    let applicantId = sessionStorage.getItem('appId')
    return this.api.getComplt(`/v1/land/uttarpradesh/fetchLandRecord?applicantId=${applicantId}`).pipe(map(resp => {
      return resp;
    }))
  }

  submitUPBreInfo(data) {

    return this.api.postData('/v1/land/uttarpradesh/verifyLand', data).pipe(map(resp => {
      return resp;
    }))
  }

  // getKhataNumberUP(data){
  //   let requestId = sessionStorage.getItem('AgriappId');

  //   return this.api.getComplt(`/v1/land/uttarpradesh/getKhata`,data).pipe(
  //     map(admin => {
  //       return admin;
  //     })
  //   )
  // }


  updateAssisted(mobileNumber) {
    return this.api.postData('/v1/assist-mode/updateAssistedJourney', { mobileNumber })
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  submitConsent(token) {
    return this.api.postData("/v1/customer/submitConsent", token).pipe(map(resp => {
      return resp;
    }))
  }

  generateApplicantSMS(mobNo) {
    return this.api.getComplt(`/v1/assist-mode/generateApplicantSmsLink?mobileNumber=${mobNo}`)
  }

  login(data) {
    return this.api.postData('/v1/dashboard/login', data).pipe(
      map(admin => {
        return admin;
      })
    )
  }

  getApplicant() {

    let applicantId = sessionStorage.getItem('kccAppId');
    return this.api.getComplt(`/v1/applicant/getApplicantRecord/${applicantId}`).pipe(map(resp => {
      return resp;
    }))
  }

  getLandRecords() {
    let applicantId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/land/rtc/getLandRecords?applicantId=${applicantId}`).pipe(map(resp => {
      return resp;
    }))
  }


  getHeaders(): Observable<any> {
    return new Observable((observer) => {
      this.getStates().subscribe((resp) => {
        let currentState;
        if (resp && resp.success && resp.data && resp.data?.length) {
          // debugger
          let sessionState = sessionStorage.getItem('state') ? sessionStorage.getItem('state').toLowerCase() : '';
          currentState = resp.data.find(obj => obj.state.toLowerCase() === sessionState);
          console.log("Current State:", currentState,sessionState);
          sessionStorage.setItem("stateHeaderObj", JSON.stringify(currentState));
        }
        observer.next(currentState || null); // Emitting a value to complete the observable
        observer.complete(); // Completing the observable
      }, (error) => {
        console.error("Error fetching headers:", error);
        observer.error(error); // Emitting an error if one occurs
      });
    });
  }



  checkIsResumable(mobileNumber) {
    return this.api.getComplt(`/v1/applicant/isResumable?mobileNumber=${mobileNumber}&mobileVerificationId=${sessionStorage.getItem('mobileVerificationId')}`).pipe(
      map(resp => {
        return resp;
      })
    )
  }


  getSummary() {
    let user = this.getUserInfo()

    return this.api.postData('/v1/dashboard/summary', { userId: user.id, roleId: user.roleId }).pipe(
      map(data => {
        return data;
      })
    )
  }

  getSanctionedData() {
    let user = this.getUserInfo()
    return this.api.postData('/v1/dashboard/sanctionedLoans', { userId: user.id, roleId: user.roleId }).pipe(
      map(data => {
        return data;
      })
    )
  }

  getFailedData() {
    let user = this.getUserInfo()
    return this.api.postData('/v1/dashboard/failureLoans', { userId: user.id, roleId: user.roleId }).pipe(
      map(data => {
        return data;
      })
    )
  }


  getCreditReport(data) {
    return this.api.postData("/v1/generate/crifReport", data).pipe(map(data => {

      return data;
    }))
  }

  getGenerateCreditReport(data) {
    return this.api.postData("/v1/generate/getCrifReport", data).pipe(map(data => {
      return data;
    }))
  }

  getCrifUserAuth(data){
    return this.api.postData("/v1/generate/answerCrifUserAuth", data).pipe(map(data =>{
      return data
    }))
  }

  getCreditReportAnswer(data) {
    return this.api.postData("/v1/generate/answerCrif", data).pipe(map(data => {

      return data;
    }))
  }

  getIncompleteData() {
    let user = this.getUserInfo()
    return this.api.postData('/v1/dashboard/incompleteLoans', { userId: user.id, roleId: user.roleId }).pipe(
      map(data => {
        return data;
      })
    )
  }

  getUserInfo() {
    if (sessionStorage.getItem('loginInfo') && typeof sessionStorage.getItem('loginInfo') == typeof "foo") {
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    } else {
      return {}
    }

  }

  getMandalAP(data) {
    return this.api.postData('/v1/land/meebhoomi/getMandals', data).pipe(
      map(res => {
        return res;
      })
    )
  }


  getTehsilUP(data) {
    return this.api.postData('/v1/land/uttarpradesh/getTehsil', data).pipe(
      map(res => {
        return res;
      })
    )
  }


  getTehsilOD(data) {
    return this.api.postData('/v1/odisha/land/getTehsil', data).pipe(
      map(res => {
        return res;
      })
    )
  }

  getVillageAP(data) {
    return this.api.postData('/v1/land/meebhoomi/getVillages', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  getVillageUP(data) {
    return this.api.postData('/v1/land/uttarpradesh/getVillage', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }



  getVillageOD(data) {
    return this.api.postData('/v1/odisha/land/getVillage', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  getSurveyNumberAP(data, search) {

    let detail = {
      "dist_code": data.dist_code,
      "mand_code": data.mand_code,
      "village_code": data.village_code,
      "surveyno": search,
      "applicantId": sessionStorage.getItem('appId')
    }


    return this.api.postData('/v1/land/meebhoomi/getSurveyNumbers', detail)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  getKhataNumberUP(data) {
    return this.api.postData('/v1/land/uttarpradesh/getKhata', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  getLandRecordsUP(data) {
    return this.api.postData('/v1/land/uttarpradesh/getLandRecord', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  getAdangalBySurveyNo(data) {
    return this.api.postData('/v1/land/meebhoomi/getLandRecords', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  deleteLrUP(data) {
    console.log("Data for deletion: ", data)
    return this.api.postData('/v1/land/uttarpradesh/deleteLandRecord', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  deleteLandRecordsAP(data) {
    console.log("delete api call: ", data)
    const requestBody = { storageId: data, applicantId: sessionStorage.getItem('appId') }
    return this.api.postData('/v1/land/meebhoomi/deleteLandRecord', requestBody)
      .pipe(
        map(res => {
          return res;
        }
        )
      )
  }

  submitAPBreInfo(isCourtCase, isSingleOwner, isMortgaged, isIrrigated, storageId) {
    const requestBody = {
      applicantId: sessionStorage.getItem('appId'),
      isCourtCase,
      isSingleOwner,
      isMortgaged,
      isIrrigated,
      storageId,
      isVerified: true
    }
    console.log(requestBody)

    return this.api.postData('/v1/land/meebhoomi/submitBre', requestBody).pipe(map(resp => {
      console.log("Bre Response: " + JSON.stringify(resp));
      return resp;
    }))
  }

  getLandRecordsAP() {
    let applicantId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/land/meebhoomi/fetchLandRecords?applicantId=${applicantId}`).pipe(map(resp => {
      return resp;
    }))
  }

  submitLrUP() {
    return this.api.postData(`/v1/land/uttarpradesh/submitLandRecords`, { 'applicantId': sessionStorage.getItem('appId') }).pipe(map(resp => {
      return resp;
    }))
  }

  submitLandsAP() {
    return this.api.postData(`/v1/land/meebhoomi/submitLands`, { 'applicantId': sessionStorage.getItem('appId') }).pipe(map(resp => {
      return resp;
    }))
  }

  getCrops(data) {
    return this.api.postData('/v1/crops/getCrops', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  getselectedCrops() {

    let applicantId = sessionStorage.getItem('appId');

    return this.api.getComplt(`/v1/loan/getSelectedCrops/${applicantId}`)
      .pipe(
        map(res => {
          return res;
        })
      )

  }

  getProposedLoanAmount(data) {
    return this.api.postData('/v1/loan/getProposedLoanAmount', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  generateDocs(data) {
    return this.api.postData('/v1/loan/generateLoanDocuments', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }






  moreInfo(res: any) {
    console.log('check rest', res)
    if (res && res.moreInfo != null && res.moreInfo != "" && res.moreInfo != undefined) {
      if (res.message == 'Success' || res.message == 'success') {
        return res.moreInfo.errormsg
      }
      else if (res && res.message != 'Success' && res.moreInfo && res.moreInfo.errDetail) {
        let error2 = res.moreInfo.err ? "-" + res.moreInfo.err : "";
        return res.message + " - " + res.moreInfo.errDetail.errormsg + "\n" + error2;
      }
      else if (res && res.message != 'Success' && res.moreInfo) {
        return res.message + " - " + res.moreInfo.errormsg
      }
      else {
        return "";
      }
    }
    else {
      return "";
    }
  }

  isAgreed(consent: string) {
    const token = sessionStorage.setItem('agree', consent);
    return token;
  }

  updateDocsData(data) {
    // return this.api.postupdateDocsDate('nesl/upDocsData', data)
    return this.api.postData(`/v1/nesl/upDocsData`, data).pipe(
      map(resp => {
        console.log("updateDocsData" + JSON.stringify(resp));
        return resp;
      })
    )

  }

  callDigiProcessNote(appId, distid, type) {
    return this.api.postData('/users/digitalprocessnote', { applicantId: appId, distid: distid, type })
      .pipe(map(res => {
        return res;
      }));
  }

  getLoanAmount(data) {
    return this.api.postData('/users/getProposedLoanAmount', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  submitMpData(data) {
    return this.api.postData('/users/updatemploandata', data)
      .pipe(map(res => {
        return res;
      }));
  }

  generateReferenceID(type) {
    return this.api.postData(`/v1/nesl/convertimage_new`, { appId: sessionStorage.getItem('mpApplicantId'), docType: type })
      .pipe(map(resp => {
        console.log("create account resp" + JSON.stringify(resp));
        return resp;
      }))
  }

  passValue(data) {
    //passing the data as the next observable\
    console.log("********** spinner data =>", data)
    this.stringSubject.next(data);
  }

  getUserConsentStatus() {
    const token1 = sessionStorage.getItem('agree');
    return token1;
  }

  getUserVerified(userid: any, type: string) {
    return this.api.postData('/users/getUserVerified', { userid, type }).pipe(
      map((res: any) => {
        return res;
      })
    )
  }

  ForgotPasswordOtp(username, sendOTP) {
    const payload = {
      "username": username,
      // "phoneNumber" : phoneNumber,
      "sendOTP": sendOTP
    }

    return this.api.postData("/v1/dashboard/resetPassword", payload).pipe(map(resp => {
      return resp;
    }))
  }

  resetPassword(username, otp, newPassword, confirmPassword) {

    const payload = {
      "username": username,
      // "phoneNumber":phoneNumber,
      "otp": otp,
      "newPassword": newPassword,
      "confirmPassword": confirmPassword
    }

    return this.api.postData("/v1/dashboard/resetPassword", payload).pipe(map(resp => {
      return resp;
    }))
  }

  submitAddUser(name, email, phoneNumber, password, role, roleId, stateIdentifier, idRoleId, staffId) {

    const payload = {
      "name": name,
      "username": phoneNumber,
      "email": email,
      "phoneNumber": phoneNumber,
      "password": password,
      "role": role,
      "roleId": roleId,
      "applicantId": sessionStorage.getItem('applicantId'),
      "reportsTo": idRoleId,
      "staffId": staffId
    }

    // const stateIdentifier:any = sessionStorage.getItem("stateIdentifier");
    return this.api.postUser('/v1/dashboard/createUser', payload, stateIdentifier).pipe(map(resp => {
      return resp;
    }))
  }


  getIP() {
    return this.api.newGetIP();
  }

  verifyID(data: any) {

    return this.api.postData('/webhook/kccaccountfetch_cbs', data).pipe(
      map(res => {
        return res;
      })
    )
  }

  verifyIDResume(data: any) {
    return this.api.postData('/webhook/resumekccjourney', data)
      .pipe(map(res => {
        return res;
      }));
  }

  getGeoLocation(): Observable<any> {
    return this.api.getComplt('/v1/ipTracking/getGeoLocation').pipe(
      tap(resp => console.log("Location" + JSON.stringify(resp)))
    );
  }

  updateStatus() {
    return this.api.postData('/users/updatenStatus', { appId: sessionStorage.getItem('mpApplicantId') })
      .pipe(map(resp => {
        console.log("updateStatus" + JSON.stringify(resp));
        return resp;
      }))
  }

  generateAadharOtp(data: any) {
    return this.api.postData('/v1/auth/aadhaar/generateAadhaarOtp', data).pipe(
      map(res => {
        return res;
      })
    )
  }

  generateOTPNTB(data) {
    return this.api.postData(`/webhook/generatentbkccotp`, data)
      .pipe(map(resp => {
        console.log("generate OTP NTB" + JSON.stringify(resp));
        return resp;
      }))
  }

  generateOTPMobileNo(data) {
    return this.api.postData(`/v1/auth/mobile/generateMobileOtp`, data)
      .pipe(map(resp => {
        console.log("generate OTP" + JSON.stringify(resp));
        return resp;
      }))
  }

  verifyOTPMobileNo(data) {
    return this.api.postData(`/v1/auth/mobile/verifyMobileOtp`, data)
      .pipe(map(resp => {
        console.log("verify OTP" + JSON.stringify(resp));
        return resp;
      }))
  }


  verifyPan(data) {
    return this.api.postData(`/v1/auth/pan/panVerification`, data)
      .pipe(map(resp => {
        console.log("verify PAN" + JSON.stringify(resp));
        return resp;
      }))
  }


  verifyPANvoterID(data) {
    let endpoint = "";
    if (data.type == "PAN") {
      endpoint = "/v1/auth/pan/panVerification"
    } else if (data.type == "VoterID") {
      endpoint = "/v1/auth/voter/voterVerification"
    }
    delete data.type;
    return this.api.postDataWithTokenPanVoter(`${endpoint}`, data)
      .pipe(map(res => {
        return res;
      }))
  }

  generateAadharOtpNTB(data) {
    return this.api.postData('/webhook/generateNTBAadharOtp', data)
      .pipe(
        map(res => {
          return res;
        }))
  }

  generateKCCOtp(data) {
    return this.api.postData('/webhook/generatekccotp', data)
      .pipe(
        map(res => {
          return res;
        }))
  }

  verifyAadharOtp(data) {
    return this.api.postData('/v1/auth/aadhaar/verifyAadhaarOtp', data).pipe(
      map(res => {
        return res;
      })
    )


  }

  verifyAadharOtpNTB(data) {
    return this.api.postData('/webhook/verifyNTBAadharOtp', data)
      .pipe(
        map(res => {
          return res;
        }))
  }

  verifyKCCOtp(data) {
    return this.api.postData('/webhook/verifykccotp', data)
      .pipe(
        map(res => {
          return res;
        })
      )
  }

  verifyOTPNTB(data) {
    return this.api.postData(`/webhook/verifyntbkccotp`, data)
      .pipe(map(resp => {
        console.log("verify OTP NTB" + JSON.stringify(resp));
        return resp;
      }))
  }

  updateLoanAmount(data) {
    return this.api.postData(`/v1/loan/updateLoanAmount`, data)
      .pipe(map(resp => {
        console.log("loan amount update" + JSON.stringify(resp));
        return resp;
      }))
  }

  getLoanDocument(data) {
    let appId = sessionStorage.getItem('appId');
    return this.api.getBlob(`/v1/loan/getLoanDocuments/${appId}/${data.type}`)
      .pipe(map(resp => {
        console.log("loan doc" + JSON.stringify(resp));
        return resp;
      }))
  }


  verify(pan) {
    const payload = {
      pan: pan.pan,
      // applicantId: "1234"
      applicantId: sessionStorage.getItem("appId"),
      aadhaar: pan.aadharNo

    };

    return this.api.postData('/v1/bPan/panAuthLinkStatus', payload).pipe(map(result => {

      return result;
    }));
  }


  verifyVoter(epic) {

    return this.api.postData('/v1/bVoter/validateBusinessVoter', { epic_no: epic.epic_no, applicantId: sessionStorage.getItem("appId"), }).pipe(map(result => {
      if (typeof result === typeof '') {
        throw result;
      }

      return result;


    }));
  }


  verifyVoterKcc(epic) {

    return this.api.postData('/v1/bVoter/validateBusinessVoter', epic).pipe(map(result => {
      if (typeof result === typeof '') {
        throw result;
      }

      return result;


    }));
  }


  getStates() {
    return this.api.getComplt('/v1/states/getStates').pipe(map(resp => {
      console.log("State" + JSON.stringify(resp));
      // sessionStorage.setItem("state",JSON.stringify(resp.data.state));
      return resp;
    }))
  }


  getGstDetails(data) {
    return this.api.postData('/v1/gst/getGstDetails', data).pipe(map(res => {
      console.log(res)
      return res;
    }
    ))
  }


  gstVerify(gst) {
    return this.api.postData("/v1/gst/gstVerify", gst).pipe(map(res => {
      console.log(res)

      return res;
    }))
  }



  gstRequestOtp(gst) {
    let gst_data = {};

    let applicantId = sessionStorage.getItem('appId');
    let username = gst.username;
    let gstin = gst.gstin;

    gst_data = {
      applicantId,
      username,
      gstin
    };


    console.log("this.gstRequestOtp", gst)
    return this.api.postData("/v1/gstotpService/sendotp", gst_data).pipe(map(res => {
      console.log(res)
      return res;
    }))
  }


  gstValidateOtp(gst) {
    let gst_data = {};
    let applicantId = sessionStorage.getItem('appId');
    let otp = gst.otp;

    gst_data = {
      applicantId,
      otp
    };

    console.log("this.verify", gst_data)
    return this.api.postData("/v1/gstotpService/verifyotp", gst_data).pipe(map(res => {
      console.log(res)
      return res;
    }))
  }




  getTelenganaLRlist(data) {
    return this.api.postData('/v1/land/telangana/getLandRecords', data).pipe(
      map(admin => {
        return admin;
      })
    )

  }


  submitTelenganaLrs(selectedLandRecordIds) {
    return this.api.postData('/v1/land/telangana/saveLandRecords', { selectedLandRecordIds, applicantId: sessionStorage.getItem('applicantId') }).pipe(
      tap(resp => console.log("states" + JSON.stringify(resp)))
    );
  }



  getEmployeeDetails(data) {
    return this.api.postData('/v1/employee/updateDetails', data).pipe(
      map(admin => {
        return admin;
      })
    )
  }

  uploadEmpDoc(fd: FormData, containerName: string, basePath: string) {
    const file = fd.get('file');
    fd.delete('file');
    fd.append('uploadedFile', file);
    fd.append('containerName', containerName);
    fd.append('basePath', basePath);
    fd.append('applicantId', sessionStorage.getItem("appId"));
    return this.api.postData('/v1/employee/uploadEmpDoc', fd)
      .pipe(map(json => {
        return json;
      }));
  }




  saveJewelleryDetails(data) {
    return this.api.postData('/v1/gold/addJewelleryDetails', data).pipe(
      map(admin => {
        return admin;
      })
    )
  }

  getAppraisal(){
    let appId = sessionStorage.getItem("appId");
    return this.api.getComplt(`/v1/gold/getAppraiserList?applicantId=${appId}`).pipe(
      map(res => {
        return res;
      })
    )
  }

  uploadGoldImg(fd: FormData, containerName: string, basePath: string) {

    const file = fd.get('file');
    fd.delete('file');
    fd.append('goldImage', file);
    fd.append('containerName', containerName);
    fd.append('basePath', basePath)
    fd.append('applicantId', sessionStorage.getItem("appId"));

    return this.api.postData(`/v1/gold/uploadGlodDoc`, fd).pipe(map(result => {
      return result;
    }))
  }

  savePledgeForm(data) {
    return this.api.postData('/v1/gold/savePledgeForm', data).pipe(
      map(admin => {
        return admin;
      })
    )
  }


  saveDeclarationForm(data) {
    return this.api.postData('/v1/gold/declarationForm', data).pipe(
      map(admin => {
        return admin;
      })
    )
  }


  saveAppraisalDetails(fd) {
    return this.api.postData('/v1/gold/saveGoldAppraisal', fd).pipe(
      map(admin => {
        return admin;
      })
    )
  }



  saveJewelleryDeclarationDetails(fd) {
    return this.api.postData('/v1/gold/jewelleryDeclarationForm', fd).pipe(
      map(admin => {
        return admin;
      })
    )
  }


  fileMovementHistory() {

    let appId = sessionStorage.getItem("appId");
    return this.api.getComplt(`/v1/files/getFileMOvementHistory?applicantId=${appId}`).pipe(
      map(admin => {
        return admin;
      })
    )
  }


  fileMovement(data) {


    return this.api.postData('/v1/files/moveFileUp', data).pipe(
      map(admin => {
        return admin;
      })
    )
  }

  // passValue(data) {
  //   //passing the data as the next observable\
  //   console.log("********** spinner data =>", data)
  //   this.stringSubject.next(data);
  // }

  // sendShowToolBarStatus(data) {
  //   //passing the data as the next observable\
  //   console.log("********** spinner data =>", data)
  //   this.showToolBar.next(data);
  // }



  // sendData(name: string) {
  //   this.neslDataEncrypted.next(this.neslDataShared);
  // }


  // getBranchDetails() {
  //   return this.api.postRes('/login/getBranchDetails', { adminId: localStorage.getItem('wl-admin-id') })
  // }

  // getImage(image) {
  //   return this.api.getComplt(image).map(result => {
  //     return result
  //   })
  // }

  // expiryLinkpost(fileName) {

  //   return this.api.postRes('/users/getSignedUrl', { 'fileName': fileName, 'type': 0 })
  //     .map(res => {
  //       return res;
  //     });
  // }









  // getLandRecordDataUsingFruitsAPI(data) {
  //   return this.api.postResMpWebhook('/webhook/getFruitDetails', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getNameFromCbs(appId) {
  //   return this.api.postResMp('/users/getApplicantData', { appId: appId })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // callDigiProcessNote(appId, distid, type) {
  //   return this.api.postResMp('/users/digitalprocessnote', { applicantId: appId, distid: distid, type })
  //     .map(res => {
  //       return res;
  //     });
  // }



  // getApplicationStatus() {
  //   return this.api.postResMp('/users/appStatus', { appId: sessionStorage.getItem('mpApplicantId') })
  //     .map(res => {
  //       return res;
  //     });
  // }


  // getDistricts() {

  //   return this.api.postResMp('/land-records/getDistricts', {})
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getTehsil(id) {

  //   return this.api.postResMp('/land-records/getTehsils', { distid: id })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getHalka(id) {
  //   return this.api.postResMp('/land-records/getHalkas', { distid: id.distid, tehid: id.tehid })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getVillage(id) {
  //   return this.api.postResMp('/land-records/getVillages', { distid: id.distid, tehid: id.tehid, halkaid: id.halkaid, })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getKhasraDetails(lgdcode) {
  //   return this.api.postResMpWebhook('/webhook/getKhasraList', { lgdcode })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getKhasraLandDetails(data) {
  //   return this.api.postResMpWebhook('/webhook/getLandRecords', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getKhasraOwnerDetails(data) {
  //   return this.api.postResMp('/land-records/getKhasraOwnerDetails', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getBREStatus(data) {
  //   return this.api.postResMp('/land-records/getBreStatus', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getBREStatusKA(data) {
  //   return this.api.postResMp('/land-records/getBreStatusKA', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // callSatsure(data) {
  //   return this.api.postResMp('/land-records/getSatsureDetails', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getSatsureStatus() {
  //   return this.api.postResMp('/land-records/satSureStatus', { appId: sessionStorage.getItem('mpApplicantId') })
  //     .map(res => {
  //       return res;
  //     });
  // }


  // getKhasraLandOwnerDetails(data) {
  //   return this.api.postResMp('/land-records/getKhasraLandOwnerDetails', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getCropsList(data) {
  //   return this.api.postResMp('/users/getCropList', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getLongTermCropsListKA() {
  //   return this.api.postResMp('/users/getlngtrmcrp', { "crop_term": "long term" })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getLoanAmount(data) {
  //   return this.api.postResMp('/users/getProposedLoanAmount', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // submitMpData(data) {
  //   return this.api.postResMp('/users/updatemploandata', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getLoanReferenceNo(id) {
  //   return this.api.postResMp('/users/getreferenceNo', { appId: id })
  //     .map(res => {
  //       return res;
  //     });
  // }



  // callExperian(count, env) {
  //   return this.api.postResMp('/score/getcreditdata', { appId: sessionStorage.getItem('mpApplicantId'), "state": "MP", type: count, env })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // callExperianKA(count, env) {
  //   return this.api.postResMp('/score/getcreditdata', { appId: sessionStorage.getItem('mpApplicantId'), "state": "KA", type: count, env })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // callCFD(cfddata) {
  //   return this.api.postResMpWebhook('/webhook/checkForCFD', { pan_no: cfddata.pan_no, appId: cfddata.appId })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getOverAllStatus(appId) {
  //   return this.api.postRes('/users/getOverallStatus', { appId: appId })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // expiryLinkpost2(fileName) {

  //   return this.api.postRes('/users/getSignedUrl', { 'fileName': fileName, 'type': 1 })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getApplicantID() {
  //   return localStorage.getItem('applicantId');
  // }

  // getCustId() {
  //   return localStorage.getItem('wl-custId');
  // }

  // getAdminID() {
  //   return localStorage.getItem('wl-admin-id');
  // }

  // getEverythingReport(id) {
  //   return this.api.newGet(`/applicants/${id}`);
  // }



  // getProfile() {
  //   return this.api.newGet(`${this.baseUrl}/profile`).map(profile => {
  //     console.log("profile app " + JSON.stringify(profile))
  //     // profile.img = (profile && profile.img) ? ENV.imageUrl.slice(0, -1) + profile.img : null;
  //     return profile;
  //   });
  // }

  // updateProfile(profile) {
  //   return this.api.put(`${this.baseUrl}/profile`, profile);
  // }

  // uploadProfilePic(fd: FormData) {
  //   fd.append('applicantId', this.applicantId);
  //   const file = fd.get('file');

  //   fd.delete('file');
  //   fd.set('file', file);

  //   console.log(fd.getAll('file'))

  //   return this.api.newPost(`/users/profileUpload`, fd).map(result => {
  //     return result;
  //   });
  // }

  // getVerificationStatus() {
  //   return this.api.newGet(`/users/validation/${this.applicantId}/history`);
  // }

  // getEverything() {
  //   return this.api.newGet(this.baseUrl);
  // }

  // getCoApplicantData(coapp) {
  //   return this.api.newGet(`/applicants/` + coapp);
  // }

  // getReport() {
  //   // return this.api.newGet(`/pdf/${this.applicantId}`);pdf/getpdftestubi/61b49e1323e6183600bc0679
  //   // return this.api.newGet(`/pdf/getpdf/${this.custId}`);getpdftestubiv1
  //   // return this.api.newGet(`/pdf/getpdftestubi/${this.applicantId}`);
  //   return this.api.newGet(`/pdf/getpdftestubiv1/${this.applicantId}`);


  // }

  // getConsentReport() {
  //   // return this.api.newGet(`/pdf/${this.applicantId}`);pdf/getpdftestubi/61b49e1323e6183600bc0679
  //   // return this.api.newGet(`/pdf/getpdf/${this.custId}`);
  //   return this.api.newGet(`/pdf/getpdfconsentformubi/${this.applicantId}`);

  // }


  // getAadharReport() {
  //   return this.api.newGet(`/aadhaar-applicants/pdf/${this.applicantId}`);
  // }

  // getLoans() {
  //   return this.api.newGet(`${this.baseUrl}/loans`);
  // }

  // share(share) {
  //   return this.api.newPost(`/pdf/shareLoanKey`, share);
  // }

  // uploadDocument(fd: FormData, docType: string) {
  //   return this.api.newPost(`/users/upload/${this.applicantId}/${docType}`, fd).map(result => {
  //     console.log('Document Upload Res Service: ', result);
  //     result = ENV.imageUrl + result;
  //     return result;
  //   })
  // }

  // updateFormData(bankName, data) {
  //   const appData = {
  //     appData: data
  //   };

  //   console.log("appData " + appData);
  //   return this.api.newPost(`/loan-app`, { applicantId: this.applicantId, bankName: bankName, appData: data }).map(res => {
  //     console.log('Update Form Data : ', res);

  //     return res;
  //   })
  // }

  // getFormData(bankName) {
  //   return this.api.newGet(`/loan-app/getAppData?applicantId=` + this.applicantId + '&bankName=' + bankName);
  //   // return this.api.newGet(`/loan-app/getAppData?applicantId=`+ "5ac76a235c578b12c8e55b85" + '&bankName=' + 'axis');
  //   // .map(res => {"5ac76a235c578b12c8e55b85"
  //   // console.log('Update Form Data : ', res);

  //   // return res;
  //   // })
  // }

  // sanitization(name) {
  //   const payload = { applicantId: this.applicantId, name1: name }

  //   return this.api.sanpost('matchName', payload).map(res => {
  //     console.log('Match Name: ', res)
  //     return res;
  //   })
  // }

  // matchPan(pan) {
  //   const payload = { applicantId: this.applicantId, pan1: pan }

  //   return this.api.post('matchPan', payload).map(res => {
  //     console.log('Match PAN: ', res);
  //     return res;
  //   })
  // }

  // getAutofill() {
  //   return this.api.newPost(`/users/autofill`, { applicantId: this.applicantId }).map(autofill => {
  //     console.log('Autofill Service: ', autofill);
  //     if (autofill.gender == 'M') { autofill.gender = 'Male' }
  //     else if (autofill.gender == 'F') { autofill.gender = 'Female' }
  //     return {
  //       basicAuto: {
  //         name: autofill.Name,
  //         fatherName: autofill.fatherName,
  //         gender: autofill.gender,
  //         mobileNo: autofill.ApplicantMobileNo
  //       },
  //       creditAuto: {
  //         firstName: autofill.panName,
  //         gender: autofill.gender,
  //         dateOfBirth: autofill.aadhaarDob,
  //         flatno: autofill.address && autofill.address.substring(0, 40),
  //         pan: autofill.panNo,
  //         pincode: autofill.aadhaarPinCode,
  //         email: autofill.email,
  //         city: autofill.city,
  //         // state: autofill.state,
  //       }
  //     }
  //   })
  // }

  // getCreditHistory() {
  //   return this.api.newGet(`${this.baseUrl}/creditReport`);
  // }

  // convertToPdf(htmlObj) {
  //   return this.api.pdfPost('/ekyc/convertbase64', htmlObj).map(res => {
  //     console.log("pdf print " + res)
  //     return res;
  //   });
  // }

  // esignDoc(payload) {
  //   return this.api.eSignPost('', payload).map(res => {
  //     console.log("raw json in app " + res);
  //     return res;
  //   })
  // }

  // getSignedDoc(documentId) {
  //   return this.api.docGet(`/sr/details?documentId=` + documentId + '&verificationDetails=false').map(res => {
  //     console.log("api res " + res);
  //     return res;
  //   })
  // }

  // uploadPdfToS3(files, bankName, formType) {

  //   var fd = new FormData();
  //   fd.append('base64Stream', files);
  //   fd.append('applicantId', this.applicantId);
  //   fd.append('formType', formType);
  //   fd.append('bankName', bankName);
  //   // const pdfObj = {
  //   //   base64Stream : files,
  //   //   applicantId : this.applicantId,
  //   //   formType : formType,
  //   //   bankName : bankName
  //   // }

  //   return this.api.newPost(`/ekyc/uploadFormToS3`, fd).map(res => {
  //     return res;
  //   });
  // }

  // getAccessToken() {

  //   return this.api.postRes('/users/getAccessToken', { applicantId: this.applicantId })
  //     .map(res => {
  //       return res
  //     });
  // }

  // getDigidata() {

  //   return this.api.postRes('/users/getDigidata', { applicantId: this.applicantId })
  //     .map(res => {
  //       return res
  //     });
  // }

  // getUserInfo(code) {
  //   var authObj = {
  //     appId: this.applicantId,
  //     clientId: ENV.digilocker.clientId,
  //     code: code,
  //     clientSecret: ENV.digilocker.clientSecret,
  //     redirectUri: ENV.digilocker.redirect_Uri
  //   }
  //   return this.api.postRes('/users/accessToken', authObj)
  //     .map(res => {
  //       return res
  //     });
  // }

  // logout(token, auth) {
  //   return this.api.postRes('/users/revokeToken', { token: token, auth: auth })
  //     .map(res => {
  //       return res
  //     });
  // }

  // getIssueDocuments(token) {
  //   return this.api.postRes('/users/getissueddoc', { token: token })
  //     .map(res => {
  //       return res
  //     });

  // }

  // getFile(fileUri, token) {
  //   return this.api.postDigi('/users/filefromuri', { uri: fileUri, token: token })
  //     .map(res => {
  //       // return res
  //       console.log("responseeee " + JSON.stringify(res));
  //       return res;
  //     });
  // }

  // updateDigiData(path, data, type) {

  //   console.log("update digi data in applicant service");

  //   if (type === "data") {
  //     this.dataObj = {
  //       applicantId: this.applicantId,
  //       digidata: data,
  //       type: type,
  //       index: null,
  //       accesspath: "",
  //     };
  //   } else if (type === "access_path") {
  //     this.dataObj = {
  //       applicantId: this.applicantId,
  //       digidata: data,
  //       type: type,
  //       index: 0,
  //       accesspath: path,
  //     };
  //   }

  //   return this.api.postDigi('/users/updatedigidata', this.dataObj)
  //     .map(res => {
  //       // return res
  //       console.log("response in Applicant Service " + JSON.stringify(res));
  //       return res;
  //     });
  // }

  // registerDigi(aadharData) {

  //   return this.api.postDigiUrlEncoded('/users/registerDigilocker', aadharData)
  //     .map(res => {
  //       // return res
  //       console.log("response in Applicant Service " + JSON.stringify(res));
  //       return res;
  //     });

  // }

  // verifydigimob(aadharData) {
  //   return this.api.postDigiUrlEncoded('/users/verifyDigiMob', aadharData)
  //     .map(res => {
  //       // return res
  //       console.log("response in Applicant Service " + JSON.stringify(res));
  //       return res;
  //     });
  // }

  // getAppliType() {
  //   return this.api.postRes('/users/getCustType', { appId: this.applicantId })
  //     .map(res => {
  //       return res;
  //     });

  // }

  // consentformSubmit(data) {
  //   data.applicantId = this.getApplicantID();
  //   data.consent_updated_by = this.getAdminID();
  //   return this.api.postRes('/users/updateApplicantData', data)
  //     .map(res => {
  //       return res;
  //     });
  // }


  // consentformannexureSubmit(data) {
  //   data.applicantId = this.getApplicantID();
  //   return this.api.postRes('/users/updateApplicantFinalAnnexureData', data)
  //     .map(res => {
  //       return res;
  //     });
  // }


  // consentyesornoForm(data) {
  //   return this.api.postRes('/users/ackloanrenewalsms', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getconsentformdata(data) {
  //   return this.api.postRes('/users/getApplicantLoanData', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getApplicantLoanFinalData(data) {
  //   return this.api.postRes('/users/getApplicantLoanFinalData', data)
  //     .map(res => {
  //       return res;
  //     });
  // }

  // getBreStatusMPOverall(appId) {
  //   return this.api.newGet(`/users/getBreStatus?applicantId=${appId}`);
  // }

  // getcropsdata() {
  //   return this.api.newGet('/crops/getcropslist');
  // }

  // getcropsdataRenewalConsent(data) {
  //   return this.api.newGet(`/crops/getcropslist?distId=${data.distId}`);
  // }

  // getLandDetails() {
  //   return this.api.newGet(this.getBaseUrl);
  // }

  // getConsentStatus(data) {
  //   return this.api.postRes('/users/consentStatus', { applicantId: data })
  //     .map(res => {
  //       return res;
  //     });
  // }

  // consentOtp(data) {
  //   return this.api.postRes(`/users/otp`, data)
  //     .map(resp => {
  //       console.log("consent otp resp in service " + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // verifyConsentOtp(data) {
  //   return this.api.postRes(`/users/verifyotp`, data)
  //     .map(resp => {
  //       console.log("verify consent otp resp in service " + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // satSureLogin() {
  //   return this.api.postSatSureLogin(`/webhook/satSureLogin`, {
  //     "applicantId": localStorage.getItem('applicantId')
  //   }).map(resp => {
  //     console.log("Login satsure" + JSON.stringify(resp));
  //     return resp;
  //   })
  // }

  // satSureFarm(data) {
  //   return this.api.postSatSureFarm(`/webhook/seasonFarm`, {
  //     "farm_data": JSON.parse(data),
  //     "userId": localStorage.getItem('satId'), "token": localStorage.getItem('satTkn')
  //   })
  //     .map(resp => {
  //       console.log("Satsure farm" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // satSureFarmSave(data) {
  //   return this.api.postRes(`/users/satSure`, { appId: localStorage.getItem('applicantId'), farmId: data.farmId, data: data, type: 'input' })
  //     .map(resp => {
  //       console.log("Satsure farm save" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // // getCropsSatSure(){ //old geomapping report crops
  // //   return this.api.satSureGet(`/webhook/masterDataCrop?token=${localStorage.getItem('satTkn')}`)
  // //   .map(resp => {
  // //     console.log("Satsure dropdown list" + JSON.stringify(resp));
  // //     return resp;
  // //   });
  // // }

  // getSatsureReportPdf() {
  //   return this.api.satSurePdfGet(`/users/satSure`);
  // }

  // sendSmsManual(appId) {
  //   return this.api.postRes(`/users/sendrenewalsms`, { applicantId: appId })
  //     .map(resp => {
  //       console.log("Sent SMS" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // getDPnDM() {
  //   return this.api.postResMpWebhookNesl(`/v1/users/getDocs`, { appId: sessionStorage.getItem('mpApplicantId') })
  //     .map(resp => {
  //       console.log("Sent SMS" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // postSelectedBranch(value) {
  //   console.log(value.branch_name)
  //   return this.api.postResMpWebhookNesl(`/v1/users/updateBranchDetails`, { appId: sessionStorage.getItem('mpApplicantId'), branch_code: value.branch_code, branch_name: value.branch_name })
  //     .map(resp => {
  //       console.log("Sent SMS" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // getBranches(villageData: any) {
  //   return this.api.getBranchPost(`/users/getBranchList`, villageData)
  //     .map(resp => {
  //       console.log("branches" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // toggleStatus(appId, type, status) {
  //   return this.api.postRes(`/users/updateconsentStatus`, { applicantId: appId, updatetype: type, data: status })
  //     .map(resp => {
  //       console.log("Status change" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // encryptDataNesl(data) {
  //   return this.api.postResMpWebhookNesl(`/v1/nesl/neslDataDecEnc`, { data, type: "enc", appId: sessionStorage.getItem('mpApplicantId') })
  //     .map(resp => {
  //       console.log("NESL Enc" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }



  // getSignData(data) {

  //   return this.api.postResMpWebhookNesl(`/v1/nesl/nesleSignData`, { txnID: sessionStorage.getItem('txnID') })
  //     .map(resp => {
  //       console.log("pdf from nesl" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // getSignStatus() {
  //   return this.api.postResMpWebhookNesl(`/v1/nesl/neslStatus`, { appId: sessionStorage.getItem('mpApplicantId'), txnID: sessionStorage.getItem('txnID') })
  //     .map(resp => {
  //       console.log("NESL status" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // createAccount() {
  //   return this.api.postResMpWebhookNesl(`/v1/account/create`, { applicantId: sessionStorage.getItem('mpApplicantId') })
  //     .map(resp => {
  //       console.log("create account resp" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }

  // generateReferenceID(type) {
  //   return this.api.postResMpWebhookNesl(`/v1/nesl/convertimage_new`, { appId: sessionStorage.getItem('mpApplicantId'), docType: type })
  //     .map(resp => {
  //       console.log("create account resp" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }



  // updateDocsData(data) {
  //   // return this.api.postupdateDocsDate('nesl/upDocsData', data)
  //   return this.api.postResMpWebhookNesl(`/v1/nesl/upDocsData`, data)
  //     .map(resp => {
  //       console.log("updateDocsData" + JSON.stringify(resp));
  //       return resp;
  //     })
  // }


  // getLoanDocsToDownLaod() {
  //   return this.api.postResMp('/users/getLoanDocs', { appId: sessionStorage.getItem('mpApplicantId') }).map(resp => {
  //     console.log("updateStatus" + JSON.stringify(resp));
  //     return resp;
  //   })
  // }

  // getIrrigatedLandRec(data) {
  //   return this.api.postResMp('/land-records/getIrrigatedStatus', data).map(resp => {
  //     return resp;
  //   });
  // }

  // deleteFailureLandRecords(data) {
  //   return this.api.postResMp('/loansrecord/dellanddetails', data).map(resp => {
  //     return resp;
  //   });
  // }

  // //bypass stuf below

  // verifyIDTemp(data) {
  //   return this.api.postLocal('http://localhost:8081/webhook/kccaccountfetch_cbs', data)
  //     .map(res => {
  //       return res;
  //     });
  // }



  // getBypassDataLocal(custId) {
  //   return this.api.postLocal('http://localhost:8081/webhook/demo-metadata', { custId })
  // }

  // getBypassData(custId) {
  //   let url;
  //   if (ENV.envUrl == "dev") {
  //     return this.api.postLocal('http://localhost:8081/webhook/demo-metadata', { custId })
  //   } else {
  //     return this.api.postResMpWebhook('/webhook/demo-metadata', { custId })
  //   }

  // }

  addAssetLoan(fd) {
    // fd.append('appId', this.applicantId);
    // return this.api.postRes('/users/assetLoanDetails', fd)
    //   .pipe(map(res => {
    //     return res
    //   }));
  }

  updateAssetLoan(fd) {
    // fd.append('appId', this.applicantId);
    // return this.api.postRes('/users/updateAssetLoanDetails', fd)
    //   .map(res => {
    //     return res
    //   });
  }

  deleteAsset(index, path) {
    // return this.api.postRes('/users/deleteAssetLoanDetails', { appId: this.applicantId, index: index, filePath: path })
    //   .map(res => {
    //     return res
    //   });
  }

  getManufacturers() {
    return of(this.manufacturer);
  }





  private manufacturer = [
    { id: 1, name: ' Zeal Tech Automation' },
    { id: 2, name: 'AGFA Healthcare India Private Limited(Ideal Healthcare)' },
    { id: 3, name: 'AGFA(Dhruva Imaging Pvt Ltd)' },
    { id: 4, name: 'AGFA(Medisun Medical Products)' },
    { id: 5, name: 'ASKAR MICRONS PVT LTD' }

  ];


  verifyMobNo(mobileNo) {

    return this.api.postData('/v1/customer/verifyMobileNo',
      {
        "applicantId": sessionStorage.getItem('appId'),
        "customerMobileNumber": mobileNo,
        "link": ENV.link,
      }).pipe(map(resp => {
        return resp;
      }))
  }




  verifyEmail(data) {

    return this.api.postData('/v1/customer/verifyEmail', data).pipe(map(resp => {

      return resp;
    }))
  }

  uploadProfilePic(fd: FormData, containerName: string, basePath: string) {

    const file = fd.get('file');
    fd.delete('file');
    fd.set('profileImg', file);
    let appId = sessionStorage.getItem('appId');
    fd.append('applicantId', appId)
    fd.append('containerName', containerName);
    fd.append('basePath', basePath);

    return this.api.postData(`/v1/customer/uploadImage`, fd).pipe(map(result => {
      return result;
    }));
  }

  getProfile() {
    let appId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/customer/getProfile/${appId}`).pipe(map(res => {
      return res;
    }));
  }

  getCoProfile() {
    let appId = sessionStorage.getItem('coApplicantId');
    return this.api.getComplt(`/v1/customer/getProfile/${appId}`).pipe(map(res => {

      return res;
    }));
  }

  selfLogin(payload) {
    return this.api.postData('/v1/customer/userLogin', payload).pipe(map(resp => {
      return resp;
    }))
  }

  updateProfile(data) {

    return this.api.postData('/v1/customer/customerProfile', data).pipe(map(resp => {
      return resp;
    }))

  }

  getCreditData(data) {
    data.aadhaarVerificationId = sessionStorage.getItem('aadhaarVerificationId')
    // return of(true) // bypassed and hardcoded true
    return this.api.postData(`/v1/generate/creditReport`, data)
      .pipe(map(resp => {
        console.log("generate credit score" + JSON.stringify(resp));

        return resp;
      }))

  }

  emiCalculation(data) {
    return this.api.postData('/v1/bre/calculateEmi', data).pipe(map(resp => {

      return resp;
    }))
  }


  loanDetails(data) {
    return this.api.postData('/v1/basic/otherLoanDetail', data).pipe(map(resp => {

      return resp;
    }))
  }


  goldLoanSave(data) {
    return this.api.postData("/v1/gold/savingsAccountForm", data).pipe(map(resp => {

      return resp;
    }))
  }


  fetchUsers(roleId) {
    return this.api.getComplt(`/v1/dashboard/fetchUsers?roleId=${roleId}`).pipe(map(resp => {
      return resp;
    }))
  }


  read(fd: FormData, containerName: string, basePath: string) {

    fd.append('applicantId', sessionStorage.getItem('appId'));
    // fd.append('imcome','100000');
    const bPan = fd.get('file');
    fd.delete('file');
    fd.append('file', bPan);
    fd.append('containerName', containerName);
    fd.append('basePath', basePath)

    let applicantId = sessionStorage.getItem("appId");

    return this.api.postData(`/v1/form/uploadFormAS`, fd).pipe(map(json => {
      return json;
      console.log('Form 26AS: ', json);

    }))
  }

  getProfileDetails() {
    let appId = this.getApplicantID();
    return this.api.getComplt(`/v1/customer/getProfile/${appId}`);
  }

  savePnl(fd: FormData) {
    fd.append('applicantId', this.getApplicantID());
    return this.api.postData(`/v1/incomeDetails/PandL`, fd).pipe(map(result => {
      return result;
    }));
  }

  ViewDoc() {
    return this.api.getComplt(`/v1/customer/getProfile/${this.getApplicantID()}`).pipe(map(json => {
      return json;
    }))
  }

  uploadRegDocument(fd: FormData) {
    fd.append('applicantId', sessionStorage.getItem('appId'))
    return this.api.postData(`/v1/rent/uploadRentalAgreement`, fd).pipe(map(result => {
      console.log('Document Uploaded: ', result);
      return result;
    }))
  }

  saveBalanceSheet(fd: FormData) {
    fd.append('applicantId', this.getApplicantID());
    return this.api.postData(`/v1/incomeDetails/balanceSheet`, fd).pipe(map(result => {
      return result;
    }));
  }

  sendToEsign() {
    const requestBody = {
      'applicantId': sessionStorage.getItem('appId'),
      'projectName': "Kheyti"
    }
    return this.api.postData('/v1/esign/digo/eSign', requestBody)
      .pipe(map(res => {
        return res
      }))
  }


  getEsignedDocument() {

    return this.api.getComplt(`/v1/esign/getSignedDocument?applicantId=${sessionStorage.getItem('appId')}`).pipe(map(res => {
      return res;
    }))
  }

  mobileConsent(data) {
    return this.api.postData(`/v1/customerDashboard/customerConsent`, data).pipe(map(result => {
      return result;
    }));
  }


  generateMobileOTPConsent(data) {
    return this.api.postData(`/v1/customerDashboard/generateMobileOTP`, data).pipe(map(result => {
      return result;
    }));
  }

  generateEncryptedMobileOTPConsent(data) {
    return this.api.postData(`/v1/customer/private-internal-verify-link-do-not-touch`, data).pipe(map(result => {
      return result;
    }));
  }

  verifyMobConsent(data) {
    return this.api.postData(`/v1/customerDashboard/verifyMobileOTP`, data).pipe(map(result => {
      return result;
    }));
  }

  getRiskProfileData() {
    return this.api.getComplt(`/v1/houseLoan/getRiskProfiling?applicantId=${sessionStorage.getItem('appId')}`)
      .pipe(map(res => {
        return res;
      }));
  }

  saveRiskProfileData(data) {
    return this.api.postData(`/v1/houseLoan/riskProfiling`, data).pipe(map(res => {
      return res;
    }));
  }

  saveFileDataEntry(fd: FormData) {
    fd.append('applicantId', this.getApplicantID());
    return this.api.postData(`/users/dataEntryFile`, fd)
      .pipe(map(result => {
        return result;
      }));
  }

  uploadFile(fd: FormData) {
    return this.api.postData(`/v1/housingIncomeDetails/uploadFile`, fd)
      .pipe(map(result => {
        return result.fileName;
      }));
  }

  saveIncomeDetails(data) {
    // data.applicantId = sessionStorage.getItem('appId');
    // data.custId = this.custId
    return this.api.postData('/v1/housingIncomeDetails/addIncomeDetails', data)
      .pipe(map(res => {
        console.log(res)
        return res
      }));
  }


  secureLink(fileName) {
    return this.api.postData('/users/getSignedUrl', { 'fileName': fileName, 'type': 0 })
      .pipe(map(res => {
        return res;
      }));
  }

  getHousingIncomeDetailsFile(fileName) {
    return this.api.postData('/v1/housingIncomeDetails/downloadFile', { 'fileName': fileName, 'applicantId': sessionStorage.getItem('appId') })
      .pipe(map(res => {
        return res.downloadRes;
      }));
  }

  getIncomeDetails() {
    let appId = sessionStorage.getItem('parentappId') || sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/housingIncomeDetails/getIncomeDetails?applicantId=${appId}`)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }


  savePropertyDetails(data) {
    return this.api.postData('/v1/property/calculatePropertyEmi', data)
      .pipe(map(res => {
        return res;
      }));
  }


  getPropertyDetails() {
    let appId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/property/fetchPropertyDetails?applicantId=${appId}`)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }


  savepropertyDocs(fd) {
    return this.api.postData(`/v1/property/uploadPropertyDocument`, fd)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }

  viewpropertyDocs(fd) {
    return this.api.postData(`/v1/property/viewPropertyDocument`, fd)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }

  getProcessingFee(fd) {
    return this.api.postData(`/v1/housingIncomeDetails/processingFee`, fd)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }

  getpdcvr(fd) {
    return this.api.postData(`/v1/housingIncomeDetails/pdCvr`, fd)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }

  downloadpdcvr(fd) {
    return this.api.postData(`/v1/housingIncomeDetails/downloadPdCvr`, fd)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }


  savefinalDisbursmentAmount(data){
    return this.api.postData('/v1/housingIncomeDetails/disbursmentAmount', data)
      .pipe(map(res => {
        console.log(res)
        return res;
      }));
  }


  uploadApplicationFiles(data) {
    return this.api.postData(`/v1/housing/uploadApplicationFile`, data)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }


  downloadApplicationFiles(data) {
    return this.api.postData(`/v1/housing/downloadApplicationFile`, data)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }


  sendSanctionLetter(data) {
    return this.api.postData(`/v1/housing/sendApplicationFile`, data)
      .pipe(map(res => {
        console.log(res)
        return res;

      }));
  }


  getFileReports() {
    return this.api.postData('/users/getFileReports', { applicantId: sessionStorage.getItem("appId") })
      .pipe(map(res => {
        console.log("response " + JSON.stringify(res));
        return res;
      }));
  }

  changeWestendLoanApplication(item: string, applicantId: string) {
    return this.api.postData('/v1/customer/westendLoanApplication', { applicantId, loanApplicationType: item })
      .pipe(map(res => {
        return res;
      }))
  }

  commonFileDownload(data) {
    return this.api.postData(`/v1/customer/commonDownload`, data)
      .pipe(map(res => {
        console.log("response " + JSON.stringify(res));
        return res;
      }));
  }

  otherAddressProof(data) {
    return this.api.postData(`/v1/otherAddressProof/uploadOtherAddress`, data).pipe(map(res => {
      console.log("response " + JSON.stringify(res));
      return res;
    }))
  }

  saveOtherAddressProof(data) {
    data.applicantId = sessionStorage.getItem('appId');
    return this.api.postData(`/v1/otherAddressProof/saveOtherAddress`, data).pipe(map(res => {
      console.log("response " + JSON.stringify(res));
      return res;
    }))
  }
  approveOrReject(status, comment) {
    return this.api.postData('/v1/approval/approvedOrRejected', { applicantId: sessionStorage.getItem('appId'), adminId: sessionStorage.getItem('adminId'), fileApprovalStatus: status, fileApprovalComment: comment })
      .pipe(map(res => {
        return res;
      }));
  }

  getapprovedata() {
    return this.api.postData('/v1/approval/userDataApproval', { applicantId: sessionStorage.getItem('appId'), adminId: sessionStorage.getItem('adminId'), "role": 2 })
      .pipe(map(res => {
        return res;
      }));
  }


  sendCustomerReport() {
    // let custId = encodeURIComponent(sessionStorage.getItem('PId'));
    // return this.api.getComplt(`/pdf/getOutputData?id=${custId}`);
    let appId = sessionStorage.getItem('appId');
    return this.api.postData(`/v1/sendData/pushDataToLMS`, { applicantId: appId })
      .pipe(map(res => {
        return res;
      }));
  }



  getUserLogs(appId) {
    return this.api.postData(`/v1/manageAdmins/applicantLogs`, { applicantId: appId }).pipe(map(res => {
      return res;
    }))
  }

  verifyPng(payload) {
    return this.api.postData(`/v1/png/verifyPng`, payload).pipe(map(res => {
          return res;
        })
      );
  }


getPngDetails(applicantId: string) {
  return this.api
    .getComplt(`/v1/png/viewPng/${applicantId}`)
    .pipe(
      map(res => {
        return res;
      })
    );
}




  getCoAppDetails() {
    let appId = sessionStorage.getItem("appId");
    return this.api.getComplt(`/v1/customer/dependents?applicantId=${appId}`).pipe(map(res => {
      return res;
    }))
  }

  getCoGuarDetails(applicantId: string) {
    // let appId = sessionStorage.getItem("appId");
    return this.api.getComplt(`/v1/customer/dependents?applicantId=${applicantId}`).pipe(map(res => {
      return res;
    }))
  }

  generateMobileOTPregistration(mobileNumber) {
    return this.api.postData(`/v1/entity/entityMobileOtp`, { mobileNumber }, {
      'admin-token': mobileNumber
    }).pipe(map(res => {
      return res;
    }))
  }

  verifyMobileOTPregistration(mobileNumber, otp, tncConsent, dataConsent) {
    return this.api.postData(`/v1/entity/entityVerifyMobile`, { mobileNumber, otp, tncConsent, dataConsent }, {
      'admin-token': mobileNumber
    }).pipe(map(res => {
      return res;
    }))
  }

  verifyPanRegistration(panNumber, mobileNumber) {
    return this.api.postData(`/v1/entity/entityPan`, { mobileNumber, panNumber }).pipe(map(res => {
      return res;
    }))
  }

  verifyGstRegistration(gstIn, mobileNumber) {
    return this.api.postData(`/v1/entity/entityGst`, { mobileNumber, gstIn }).pipe(map(res => {
      return res;
    }))
  }

  verifyBankRegistration(bank_acc_no, ifsc_code, mobileNumber) {
    return this.api.postData(`/v1/entity/entityBank`, { mobileNumber, bank_acc_no, ifsc_code }).pipe(map(res => {
      return res;
    }))
  }

  entityRegistration(fullData) {
    return this.api.postData(`/v1/entity/registrationForm`, fullData).pipe(map(res => {
      return res;
    }))
  }

  getEntityDetails(mobileNumber) {
    return this.api.getComplt(`/v1/entity/getEntityData/${mobileNumber}`).pipe(map(res => {
      return res;
    }))
  }

  uploadCertificate(fd: FormData, basePath: string, containerName: string, mobileNumber: string) {
    const file = fd.get('file')
    fd.delete('file')
    fd.append('certificate', file)
    fd.append('containerName', containerName)
    fd.append('basePath', basePath)
    fd.append('mobileNumber', mobileNumber)
    return this.api.postData(`/v1/entity/uploadCertificate`, fd).pipe(map(res => {
      return res;
    }))
  }

  getEntityList() {
    return this.api.getComplt(`/v1/entity/getEntities`).pipe(map(res => {
      return res
    }))
  }

  validateEntity(mobileNumber, validationType, adminId) {
    return this.api.postData(`/v1/entity/validateEntity`, { mobileNumber, validationType, adminId }).pipe(map(res => {
      return res
    }))
  }

  entityMailVerification(data) {
    return this.api.postData(`/v1/entity/entityMailVerify`, data).pipe(map(res => {
      return res
    }))
  }

  verifyEntityEmailOtp(post) {
    return this.api.postData("/v1/entity/verifyEntityEmailConsent", post).pipe(map(resp => {
      return resp;
    }))
  }

  submitEntityConsent(token) {
    return this.api.postData("/v1/entity/verifyEmailLink", token).pipe(map(resp => {
      return resp;
    }))
  }

  createWallet(adminId) {
    return this.api.postData("/v1/wallet/createWallet", adminId).pipe(map(resp => {
      return resp;
    }))
  }


  initiatePaymentRazorpay(data) {
    return this.api.postData('/v1/razorpay/generateOrder', data).pipe(map(res => {
      return res;
    }))
  }

  getWalletInfo(userId) {
    return this.api.getComplt(`/v1/wallet/getWallet/${userId}`).pipe(map(res => {
      return res;
    }))
  }

  verifyPaymentStatus(data) {
    return this.api.postData(`/v1/razorpay/getPaymentStatus`, data).pipe(map(res => {
      return res;
    }))
  }

  entityCinVerification(data) {
    return this.api.postData(`/v1/entity/verifyCin`, data).pipe(map(res => {
      return res;
    }))
  }


  siCinVerification(data) {
    return this.api.postData(`/v1/systemIntegrator/verifySystemIntegratorCin`, data).pipe(map(res => {
      return res;
    }))
  }


  coopsInvoice(data) {
    return this.api.postData(`/v1/entity/generateInvoice`, data).pipe(map(res => {
      return res;
    }))
  }


  compAnalysis(fd: FormData) {
    const file = fd.get('file')
    fd.delete('file')
    return this.api.postData('/v1/gpt/computation-sheet-analysis', fd).pipe(map(resp => {
      return resp;
    }))
  }


  customerRegistration(data: any) {
    return this.api.postData('/v1/dfid/register', data).pipe(map(resp => {
      return resp;
    }))
  }




  getPaymentStatus() {

    let appId = sessionStorage.getItem('appId');

    return this.api.getComplt(`/v1/dfid/paymentStatus?applicantId=${appId}`).pipe(map(res => {
      return res;
    }))
  }

  generateProfileMobileOTP(data) {

    return this.api.postData('/v1/otp/generate', data).pipe(map(resp => {
      return resp;
    }))
  }

  verifyProfileMobileOTP(data) {

    return this.api.postData('/v1/otp/verify', data).pipe(map(resp => {
      return resp;
    }))
  }

  generateEquifaxReport(data) {
    return this.api.postData('/v1/equifax/generateReport', data).pipe(map(resp => {
      return resp;
    }))
  }


  getcomputationReport(sheetType) {
    let appId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/gpt/computation-sheet-analysis/${appId}`).pipe(map(res => {
      return res;
    }))
  }


  getPayslipOcr(fd: FormData) {
    return this.api.postData('/v1/gpt/payslip-analysis', fd).pipe(map(resp => {
      return resp;
    }))
  }

  generateValidationReport(data) {
    return this.api.postData('/v1/customer/sendDataValidation', data).pipe(map(resp => {
      return resp;
    }))
  }


  generateMobileOTPregistrationSi(mobileNumber) {
    return this.api.postData(`/v1/systemIntegrator/systemIntegratorMobileOtp`, { mobileNumber }, {
      'admin-token': mobileNumber
    }).pipe(map(res => {
      return res;
    }))
  }

  verifyMobileOTPregistrationSi(mobileNumber, otp, tncConsent, dataConsent) {
    return this.api.postData(`/v1/systemIntegrator/systemIntegratorVerifyMobile`, { mobileNumber, otp, tncConsent, dataConsent }, {
      'admin-token': mobileNumber
    }).pipe(map(res => {
      return res;
    }))
  }

  verifyPanRegistrationSi(panNumber, mobileNumber) {
    return this.api.postData(`/v1/systemIntegrator/systemIntegratorPan`, { mobileNumber, panNumber }).pipe(map(res => {
      return res;
    }))
  }

  verifyGstRegistrationSi(gstIn, mobileNumber) {
    return this.api.postData(`/v1/systemIntegrator/systemIntegratorGst`, { mobileNumber, gstIn }).pipe(map(res => {
      return res;
    }))
  }

  verifyBankRegistrationSi(bank_acc_no, ifsc_code, mobileNumber) {
    return this.api.postData(`/v1/systemIntegrator/systemIntegratorBank`, { mobileNumber, bank_acc_no, ifsc_code }).pipe(map(res => {
      return res;
    }))
  }

  siRegistration(fullData) {
    return this.api.postData(`/v1/systemIntegrator/registrationForm`, fullData).pipe(map(res => {
      return res;
    }))
  }

  getSiDetails(mobileNumber) {
    return this.api.getComplt(`/v1/systemIntegrator/getSystemIntegratorData/${mobileNumber}`).pipe(map(res => {
      return res;
    }))
  }

  uploadCertificateSi(fd: FormData, basePath: string, containerName: string, mobileNumber: string) {
    const file = fd.get('file')
    fd.delete('file')
    fd.append('certificate', file)
    fd.append('containerName', containerName)
    fd.append('basePath', basePath)
    fd.append('mobileNumber', mobileNumber)
    return this.api.postData(`/v1/systemIntegrator/uploadCertificate`, fd).pipe(map(res => {
      return res;
    }))
  }

  getSiList() {
    return this.api.getComplt(`/v1/systemIntegrator/getSystemIntegrators`).pipe(map(res => {
      return res
    }))
  }

  validateSi(mobileNumber, validationType, adminId) {
    return this.api.postData(`/v1/systemIntegrator/validateSystemIntegrator`, { mobileNumber, validationType, adminId }).pipe(map(res => {
      return res
    }))
  }

  siMailVerification(data) {
    return this.api.postData(`/v1/systemIntegrator/systemIntegratorMailVerify`, data).pipe(map(res => {
      return res
    }))
  }

  verifySiEmailOtp(post) {
    return this.api.postData("/v1/systemIntegrator/verifySystemIntegratorEmailConsent", post).pipe(map(resp => {
      return resp;
    }))
  }

  submitSiConsent(token) {
    return this.api.postData("/v1/systemIntegrator/verifySystemIntegratorEmailLink", token).pipe(map(resp => {
      return resp;
    }))
  }

  sendEmailandSms(mobileNumber) {
    return this.api.postData("/v1/systemIntegrator/sendSystemIntegratorEmailAndSms", { mobileNumber }).pipe(map(res => {
      return res;
    }))
  }

  systemIntegratorLogin(data) {
    return this.api.postData("/v1/systemIntegratorDashboard/login", data).pipe(map(res => {
      return res;
    }))
  }

  apcobFileMovement(data) {
    return this.api.postData('/v1/files/fileMovement', data).pipe(map(res => {
      return res;
    }))
  }

  apcobFileMovementDown(data) {
    return this.api.postData('/v1/files/fileMovementDown', data).pipe(map(res => {
      return res;
    }))
  }

  getApcobFileMovements() {
    return this.api.getComplt(`/v1/files/getFileMovementHistoryApcob/${sessionStorage.getItem('appId')}`).pipe(map(res => {
      return res;
    }))
  }



  fileApprovalApcob(data) {
    return this.api.postData('/v1/files/approvalApcob', data).pipe(map(res => {
      return res;
    }))
  }

  creditEligibility() {
    let appId = sessionStorage.getItem("appId");
    return this.api.getComplt(`/v1/apcobBre/validateCreditEligibility?applicantId=${appId}`).pipe(map(res => {
      return res;
    }))
  }


  loanEmiCaculation(data) {
    //  let appId = sessionStorage.getItem("appId");
    return this.api.postData(`/v1/apcobBre/calculateLoanEligibility`, data).pipe(map(res => {
      return res;
    }))
  }
  

   updatedLoanEmiCaculation(data) {
    //  let appId = sessionStorage.getItem("appId");
    return this.api.postData(`/v1/apcobBre/updateCalculatedLoanEligibility`, data).pipe(map(res => {
      return res;
    }))
  }

  calculateLoanEligibilitySummary(){
      let appId = sessionStorage.getItem("appId");
    return this.api.postData(`/v1/apcobBre/calculateLoanEligibilitySummary`, {applicantId: appId}).pipe(map(res => {
      return res;
    }))
  }


  UploadApcobDoc(fd: FormData) {
    return this.api.postData(`/v1/apcobdoc/uploadApcobdoc`, fd).pipe(map(res => {
      return res;
    }))
  }

  cibilReport(data) {
    return this.api.postData(`/v1/cibil/getCibilConsumer`, data).pipe(map(res => {
      return res;
    }))
  }

  apcobAsset(data) {
    return this.api.postData(`/v1/apcobdoc/apcobAssetSave`, data).pipe(map(res => {
      return res;
    }))
  }

  apcobApprovalApi(appId: string) {
    return this.api.postData('/v1/files/approvalApcob', { applicantId: appId, adminId: sessionStorage.getItem("adminId") }).pipe(map(res => {
      return res;
    }));
  }



  getStatesNew(data) {
    return this.api.postData("/v1/land-record/getStates", data).pipe(map(res => {
      return res;
    }))
  }

  getDistrictsAdva(data) {
    return this.api.postData("/v1/land-record/getDistricts", data).pipe(map(res => {
      return res;
    }))
  }

  getTehsilsAdva(data) {
    return this.api.postData("/v1/land-record/getTehsil", data).pipe(map(res => {
      return res;
    }))
  }

  getRevenueCirclesAdva(data) {
    return this.api.postData("/v1/land-record/getRevenueCircle", data).pipe(map(res => {
      return res;
    }))
  }

  getVillagesAdva(data) {
    return this.api.postData("/v1/land-record/getVillages", data).pipe(map(res => {
      return res;
    }))
  }


  getSurveyAdva(data) {
    return this.api.postData("/v1/land-record/getSurvey", data).pipe(map(res => {
      return res;
    }))
  }



  getSubSurveyAdva(data) {
    return this.api.postData("/v1/land-record/getSubsurvey", data).pipe(map(res => {
      return res;
    }))
  }


  getLandRecordsAdva(data) {
    return this.api.postData("/v1/land-record/getLandRecords", data).pipe(map(res => {
      return res;
    }))
  }

  recieveLandRecordsAdva(data) {
    return this.api.postData("/v1/land-record/receiveLandRecords", data).pipe(map(res => {
      return res;
    }))
  }

  fetchLandRecordsAdva(data) {
    return this.api.postData("/v1/land-record/fetchLandRecord", data).pipe(map(res => {
      return res;
    }))
  }

  generateSSo(){
    return this.api.postData('/v1/vendorSso/generateSsoToken', {
      applicantId: sessionStorage.getItem('appId')}).pipe(map(res => {
      return res;
    }))
  }

  setGoldRate(data){
     return this.api.postData('/v1/goldRate/setGoldRate', data).pipe(map(res => {
      return res;
    }))
  }

   getGoldRate(data, ltvPercentage?: number){
     const ltvQuery = ltvPercentage !== undefined ? `&ltvPercentage=${ltvPercentage}` : '';
     return this.api.getComplt(`/v1/goldRate/getGoldRate?date=${data}${ltvQuery}`).pipe(map(res => {
      return res;
    }))
  }
  
getAllGoldRate(){
     return this.api.getComplt(`/v1/goldRate/getAllGoldRates`).pipe(map(res => {
      return res;
    }))
  }

  saveGoldLoanMargin(data){
     return this.api.postData('/v1/goldLoanMargin/save', data).pipe(map(res => {
      return res;
    }))
  }

  getGoldLoanMargin(applicantId){
     return this.api.getComplt(`/v1/goldLoanMargin/get?applicantId=${applicantId}`).pipe(map(res => {
      return res;
    }))
  }

  postfile(data){
    return this.api.postData(`/v1/files/moveFile`,data).pipe(map(res => {
      return res;
    }))
  }

  getfile(appId){
    return this.api.getComplt(`/v1/files/fileMovementLog/${appId}`).pipe(map(res => {
      return res;
    }))
  }

  private async compressFile(file: File): Promise<File> {
    if (!file || file.type !== 'application/pdf') {
      return file;
    }
    try {
      const buffer = await file.arrayBuffer();
      const cs = new CompressionStream('gzip');
      const writer = cs.writable.getWriter();
      writer.write(new Uint8Array(buffer));
      writer.close();

      const chunks: Uint8Array[] = [];
      const reader = cs.readable.getReader();
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
      }

      const total = chunks.reduce((n, c) => n + c.length, 0);
      const compressed = new Uint8Array(total);
      let offset = 0;
      for (const chunk of chunks) { compressed.set(chunk, offset); offset += chunk.length; }

      return new File([compressed], file.name, { type: 'application/pdf' });
    } catch {
      return file;
    }
  }

  uploadform(data: FormData) {
    const file = data.get('file') as File;
    if (!file) {
      return this.api.postData(`/v1/formsUpload/uploadDocument`, data).pipe(map(res => res));
    }
    return from(this.compressFile(file)).pipe(
      switchMap((compressed) => {
        data.set('file', compressed, compressed.name);
        return this.api.postData(`/v1/formsUpload/uploadDocument`, data);
      }),
      map(res => res)
    );
  }

  getupload(applicantId?){
    const appId = applicantId || sessionStorage.getItem('appId') || '';
    return this.api.getComplt(`/v1/formsUpload/getDocuments?applicantId=${encodeURIComponent(appId)}`).pipe(map(res => {
      return res;
    }))
  }

  approveDocument(data){
    return this.api.postData(`/v1/formsUpload/approveDocument`, data).pipe(map(res => {
      return res;
    }))
  }

  getPriceRecords(type: string){
    return this.api.getComplt(`/v1/priceRecord/getAllPrices?type=${type}`).pipe(map(res => {
      return res;
    }))
  }

  postShare(data){
    return this.api.postData(`/v1/sharePrice/setSharePrice`, data).pipe(map(res => {
      return res;
    }))
  }

  setPriceRecord(data){
    return this.api.postData(`/v1/priceRecord/setPrice`, data).pipe(map(res => {
      return res;
    }))
  }

  getsubmittedForms(){
    
    let appId = sessionStorage.getItem('appId');
     return this.api.getComplt(`/v1/formsUpload/getDocuments?applicantId=${appId}&type=forms`).pipe(map(res => {
      return res;
    }))
  }

  getRepayment(){
    let appId = sessionStorage.getItem('appId');
    return this.api.getComplt(`/v1/repayment/getRepayments?applicantId=${appId}`).pipe(map(res => {
      return res;
    }))
  }

  updateScheduleEntry(sequence: number, interest_due: number, charges_due: number){
    let appId = sessionStorage.getItem('appId');
    const payload = {
      applicantId: appId,
      sequence: sequence,
      interest_due: interest_due,
      charges_due: charges_due
    };
    return this.api.postData('/v1/repayment/updateScheduleEntry', payload).pipe(map(res => {
      return res;
    }))
  }
}
